<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <transfer-breadcrumbs :search-request="searchRequest" :product="product" />
        </template>
        <template v-slot:sidebar>
            <transfer-order-summary
                :offers="[offer]"
                :search-request="searchRequest"
                :info="info"
                :product="product"
                :info-return-transfer="infoReturnTransfer"
                :return-transfer-offer="offerReturnTransfer"
                :search-request-return-transfer="searchRequestReturnTransfer"
                :extra-services="extraServices"
                :additional-options="bookingAdditionalOptions"
            />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import ConfirmationStatus from '~src/components/booking/confirmationStatus.src'
    import TransferOrderSummary from '~src/components/transfers/booking/transferOrderSummary.src'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import {TransferPageMixin} from '@/components/transfers/mixins/TransferPageMixin.vue'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import TransferBreadcrumbs from '@/components/transfers/TransferBreadcrumbs.vue'
    import {TransferStoreMixin} from '@/mixins/TransferStoreMixin.vue'

    @Component({
        components: {
            TransferBreadcrumbs,
            ConfirmationPageLayout,
            ConfirmationStatus,
            Breadcrumbs,
            TransferOrderSummary,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class TransferConfirmationPage extends mixins(TransferPageMixin, ConfirmationPageMixin, TransferStoreMixin) {
        info = {
            images: [],
        }

        infoReturnTransfer = {
            images: [],
        }

        //TODO Save info in basket
        async mounted() {
            await this.$store.restored
            try {
                this.info = await this.$api.transferInfo.get({offerKey: this.productStore.prepareBookRequest.offerKey})
                if (this.isReturnTransfer) {
                    this.infoReturnTransfer = await this.$api.transferInfo.get({
                        offerKey: this.productStore.prepareBookReturnTransferRequest.offerKey,
                    })
                }
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }

        get isReturnTransfer() {
            return this.$route.query.returnTransfer
        }

        get basketItem() {
            return this.productStore.basketItem(this.productStore.prepareBookRequest.offerKey)
        }

        get basketItemReturnTransfer() {
            return this.isReturnTransfer
                ? this.productStore.basketItem(this.productStore.prepareBookReturnTransferRequest.offerKey)
                : null
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get searchRequestReturnTransfer() {
            return this.isReturnTransfer ? this.basketItemReturnTransfer.searchRequest : null
        }

        get product() {
            return this.basketItem.product
        }

        get productReturnTransfer() {
            return this.basketItemReturnTransfer.product
        }

        get offer() {
            return this.product.offers.find(offer => offer.offerKey === this.basketItem.offerKey)
        }

        get offerReturnTransfer() {
            return this.isReturnTransfer
                ? this.productReturnTransfer.offers.find(
                      offer => offer.offerKey === this.basketItemReturnTransfer.offerKey
                  )
                : null
        }

        get extraServices() {
            return [
                this.productStore.prepareBookRequest.extraServices,
                this.productStore.prepareBookReturnTransferRequest.extraServices,
            ]
        }
    }

    export default TransferConfirmationPage
</script>
